// extracted by mini-css-extract-plugin
export default {"container":"info-referral-card_container__ijEAa","icon":"info-referral-card_icon__+rmWu","textWrapper":"info-referral-card_textWrapper__CK007"};